import React from 'react';
import type { IterationLabelsAccordionHeaderProps } from './types';

export const IterationLabelsAccordionHeader: React.FC<
  IterationLabelsAccordionHeaderProps
> = ({ entryCount, onClick }) => (
  <div className="iteration-labels__accordion__header" onClick={onClick}>
    <div className="iteration-labels__accordion__title">Iteration Labels</div>

    <div className="iteration-labels__accordion__subtitle">
      {entryCount} {entryCount === 1 ? 'entry' : 'entries'}
    </div>
  </div>
);
